import { type JSX, PropsWithChildren } from 'react';

import { EmptyPlaceholder } from 'config';

import * as Styles from './styles';
import { NumberCardProps } from './types';

const NumberCard = ({
  count,
  heading,
  children,
  subHeading,
  ...props
}: PropsWithChildren<NumberCardProps>): JSX.Element => {
  return (
    <Styles.Wrapper {...props}>
      <div>
        <Styles.Heading>{heading}</Styles.Heading>
        <Styles.SubHeading>{subHeading}</Styles.SubHeading>
      </div>
      <Styles.Number>{children || (count ?? EmptyPlaceholder)}</Styles.Number>
    </Styles.Wrapper>
  );
};

export { NumberCard };
